const DEFAULT_POST_LOGIN_PATH = '/dashboard';

/** Only allow same-origin relative paths (open-redirect safe). */
export function sanitizeNextPath(path) {
  if (!path || typeof path !== 'string') return null;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/')) return null;
  if (trimmed.startsWith('//')) return null;
  if (trimmed.startsWith('/auth/login')) return null;
  return trimmed;
}

export function buildLoginPath(from) {
  const raw =
    typeof from === 'string'
      ? from
      : from?.pathname
        ? `${from.pathname}${from.search || ''}`
        : `${window.location.pathname}${window.location.search}`;

  const next = sanitizeNextPath(raw) || DEFAULT_POST_LOGIN_PATH;
  return `/auth/login?next=${encodeURIComponent(next)}`;
}

export function resolvePostLoginPath(searchParams, stateFrom) {
  const fromQuery = searchParams?.get?.('next');
  const legacyRedirect = searchParams?.get?.('redirect');
  const fromState = stateFrom?.pathname
    ? `${stateFrom.pathname}${stateFrom.search || ''}`
    : null;

  return (
    sanitizeNextPath(fromQuery) ||
    sanitizeNextPath(legacyRedirect) ||
    sanitizeNextPath(fromState) ||
    DEFAULT_POST_LOGIN_PATH
  );
}

export function preserveNextInPath(basePath, searchParams) {
  const next = searchParams?.get?.('next');
  const safe = sanitizeNextPath(next);
  if (!safe) return basePath;
  return `${basePath}?next=${encodeURIComponent(safe)}`;
}
